import React from 'react'
import clsx from 'clsx'

type Props = {
	children?: React.ReactNode
	size?: number
	mediaWidth: number
}

const DatatableFilterCol = ({ children, size, mediaWidth }: Props) => {
	return (
		<div
			className={clsx({ 'w-full lg:table-cell': true, 'lg:w-auto': !size })}
			style={size && mediaWidth >= 1024 ? { width: `${size}px` } : {}}
		>
			{children}
		</div>
	)
}

export default DatatableFilterCol
